<div class="page-title-bar">
  <div class="container">
    <h1 class="mb-3 mt-3">{{ heading }}</h1>
    <p class="lead text-xxl">{{ subHeading }}</p>
  </div>
</div>
